import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations
}